import { render, staticRenderFns } from "./ArticleAutocomplete.vue?vue&type=template&id=7bac359e&scoped=true"
import script from "./ArticleAutocomplete.vue?vue&type=script&lang=ts"
export * from "./ArticleAutocomplete.vue?vue&type=script&lang=ts"
import style0 from "./ArticleAutocomplete.vue?vue&type=style&index=0&id=7bac359e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bac359e",
  null
  
)

export default component.exports